module.exports = __webpack_public_path__ + "img/16.b7bfc275.png";